var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { styled } from '@mui/material';
import React from 'react';
import { LabelPlacement } from '../Form/FormInputProps';
import FormLabel from '../Form/FormLabel';
export var SFormLabel = styled(FormLabel, {
    shouldForwardProp: function (prop) { return prop !== 'labelPlacement'; },
    name: 'MuiFormControl',
    overridesResolver: function (_a) {
        var labelPlacement = _a.labelPlacement, theme = _a.theme;
        var customOverrides = theme.components.MuiFormControl.customOverrides;
        return [customOverrides["".concat(labelPlacement, "InputField")], customOverrides[labelPlacement]];
    },
})({});
// Can be used as a standalone component.
var InputLabel = function (_a) {
    var boldLabel = _a.boldLabel, optional = _a.optional, _b = _a.labelPlacement, labelPlacement = _b === void 0 ? LabelPlacement.TOP : _b, required = _a.required, label = _a.label, children = _a.children;
    return (React.createElement(SFormLabel, __assign({}, { boldLabel: boldLabel, optional: optional, labelPlacement: labelPlacement, required: required }),
        label,
        children));
};
export default InputLabel;
